export default __webpack_public_path__ + "static/media/3084.8c3a6b04.jpg";